import styled from "styled-components";
import Colors from "@colors";

export const Span = styled.span`
  padding: 0 0 8px;
  font-weight: bold;
  color: ${Colors.textGreen};
`;
